export default __webpack_public_path__ + "static/safety-hq-monogram-white-8046314951b92757631230b987f1006a.png";